/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PlatformFee/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AchFeeInput from './AchFeeInput/index'
import CardFeeInput from './CardFeeInput/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function PlatformFee({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Settings/Content/FeeMode/PlatformFee"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<CardFeeInput
  viewPath={`${viewPath}/CardFeeInput`}
/>
<AchFeeInput
  viewPath={`${viewPath}/AchFeeInput`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral500}
 text="All card and ACH transactions will include the configured platform fee."
/>
{children}
</React.Fragment>)
}